<button type="button" class="linkedin-login-button mt-2 flex align-items-center" (click)="redirectToLinkedin()">
  <span class="linkedin-login-button__icon mr-2">in</span>
  <span class="linkedin-login-button__text" class="flex-1 text-center">
    {{ (signup ? 'AUTH.LINKEDIN_LOGIN.SIGNUP' : 'AUTH.LINKEDIN_LOGIN.LOGIN') | translate }}
  </span>
</button>
